import store from '../store'
import authentication from '../Authentication'

export default {
  handleRejectedCall (error) {
    // if the error message is formatted in an unexpected way, logout.
    if (error.response === undefined) {
      //  authentication.logout()
    } else if ('status' in error.response) {
      //  set the error message
      store.commit('setError', error.response.data.error)
      //  handle the code
      const code = error.response.status
      switch (code) {
        case 401:
          this.handle401()
          break
        case 403:
          this.handle403()
          break
        default:
          // if an unknown exception is discovered, logout.
          console.log('issue')
        //  authentication.logout()
      }
    } else {
      // if no status code is found in the error, logout.
      authentication.logout()
    }
  },
  handle401 () {
    authentication.logout()
  },
  handle403 () {}
}



// WEBPACK FOOTER //
// ./src/api/errors.js